<template>
    <div class="buying-choice details-bg-color border-bottom mb-1">
        <!-- {{ buyingChoices }} -->
        <div class="row py-5 m-0">
            <div class="col-12 col-lg-2 col-md-2 d-flex justify-content-center align-items-center my-5">
                <img class="img-fluid" :src="addToCartSection.image" style="width: 100%; height: auto; max-height: 250px" ref="myImgRef" />
            </div>
            <div class="col-12 col-lg-10 col-md-10">
                <h4 class="fw-normal">{{ addToCartSection.title }}</h4>
                <!-- <p class="fs-6">
                    Configured Price &nbsp;&nbsp;{{ itemCurrency }} <strong>{{ convertPrice(addToCartSection.configurePrice) }}</strong>
                </p> -->
                <!-- <p class="fs-6 mt-4 my-2 text-secondary">{{ addToCartSection.firstPera }}</p>
                <p class="fs-6 mt-4 my-2 text-secondary">{{ addToCartSection.secondPera }}</p> -->
                <div class="row">
                    <!-- {{ selectSize.length }} -->
                    <div class="col-12 col-lg-8 col-md-8 p-0 px-1">

                        <SelectedItems bgColor="#F9F7F3" v-model="selectSize" :list="buyingChoices" />

                    </div>
                    <div class="col-12 col-lg-4 col-md-4">
                        <!-- <div class="col-6 col-lg-4 col-md-4 p-0 px-1">
                            <SelectDesign label="Qty" bgColor="#F9F7F3" v-model="selectQty" :list="qtyList" />
                        </div> -->
                        <div class="col-6 col-lg-4 col-md-4 p-0 px-1">
                            <SelectedPrice
                                :label="`Price ${itemCurrency}`"
                                bgColor="#F9F7F3"
                                :item="total"
                            />
                        </div>

                        <div class="col-6 col-lg-8 col-md-8 p-0 px-1">
                            <FormBaseButton caption="ADD TO CART" icon="" @click.prevent="addToCart" :loading="loading"
                                class="w-100 rounded-0 fs-7 my-2" color="btn-secondary" style="height: 44px"
                                :disabled="selectSize.length <= 0" />
                            <FormBaseButton
                                caption="CHECKOUT NOW!"
                                icon=""
                                @click.prevent="checkout"
                                :loading="loading"
                                class="w-100 rounded-0 fs-7 my-2"
                                color="btn-secondary"
                                style="height: 44px"
                                :disabled="selectSize.length <= 0"
                            />
                            <!-- <p v-if="addToCartSection?.sku == null && selectQty?.name > 0">could no found</p> -->
                        </div>
                    </div>
                </div>
                <!-- <p class="fs-6 mt-1 text-secondary" v-if="addToCartSection.deliveryInfo">
                    Configured this item to view delivery information to 94925.
                </p>
                <p class="fs-6 my-1 text-secondary" v-if="addToCartSection.returnPolicy">
                    <span v-if="addToCartSection.returnPolicyText.length"></span>
                    Learn more about our Return policy.
                </p> -->
                <!-- <p class="fs-6 text-secondary" v-if="addToCartSection.model.length">
                    Model: {{ addToCartSection.model }}
                </p> -->
            </div>
        </div>
        <CommonsToaster ref="toaster" />
    </div>
</template>

<script setup>
import { useCartStore } from "@/stores/cart.js";
import { useCurrenciesStore } from "@/stores/currencies-store";

const currenciesStore = useCurrenciesStore();
const cartStore = useCartStore();

const props = defineProps({
    section: {
        type: Object,
        default: null,
    },
    item: {
        type: Object,
        default: null,
    },
    finishes: {
        type: String,
        default: "",
    },
    sourceType: {
        type: String,
        default: "Bundle"
    },
    attachments: {
        type: Array,
        default: () => [],
    },
});

const image = ref("");
const title = ref("");
const configurePrice = ref("");
const firstPera = ref("");
const secondPera = ref("");
const deliveryInfo = ref(false);
const returnPolicy = ref(false);
const returnPolicyText = ref("");
const model = ref("");
const loading = ref(false);
const toaster = ref(null);
const itemRef = toRef(props, 'item');

const finishList = ref([
    {
        id: "finish1",
        name: "Grey Mehogony",
    },
    {
        id: "finish2",
        name: "Grey 2 Teak Wood",
    },
    {
        id: "finish3",
        name: "Dark Mehogony",
    },
]);

// const qtyList = ref([
//     {
//         id: "qty0",
//         name: 0,
//         selected: true,
//     },
//     {
//         id: "qty1",
//         name: 1,
//     },
//     {
//         id: "qty2",
//         name: 2,
//     },
//     {
//         id: "qty3",
//         name: 3,
//     },
//     {
//         id: "qty4",
//         name: 4,
//     },
//     {
//         id: "qty5",
//         name: 5,
//     },
// ]);

const addToCartSection =ref({
    image: "/images/landing/Bed-1.png",
    title: "AKHTAR BARAK OBAMA BED",
    configurePrice: "BDT 54999/-",
    firstPera: "",
    secondPera: "Headboard is an oversized piece that cannot be disassembled. We recommend measur",
    deliveryInfo: true,
    returnPolicy: true,
    returnPolicyText: "This item is special order and cannot be returned.",
    model: "AFL-BED-478",
    sku: null
});

const selectFinish = ref(finishList.value[0]);
// const selectSize = ref(sizeList.value[0]);
const selectSize = ref([]);
// const selectQty = ref(qtyList.value[0]);

const convertPrice = (num) => {
    let val = 0;
    let currency = "BDT";
    if (
        currenciesStore.country &&
        currenciesStore.country.currency != "BDT" &&
        currenciesStore.country.rate > 0
    ) {
        if (num > 0) {
            val = (num / Number(currenciesStore.country.rate)).toFixed(2);
        }
        currency = currenciesStore.country.currency;
    } else {
        val = Number(num).toFixed(2);
    }
    return `${val}`;
};
const itemCurrency = computed(() => {
    let currency = "BDT";
    if (
        currenciesStore.country &&
        currenciesStore.country.currency &&
        currenciesStore.country.currency.length > 0
    ) {
        currency = currenciesStore.country.currency;
    }

    return currency;
});


const globalDiscount = computed(() => {
    if (!props.item?.id) {
        return 0;
    }

    let discountPrice = 0;
    let salesPrice = Number(addToCartSection.value.configurePrice);
    let categoryIds = itemRef.value?.categories;

    if (globalDiscountStore?.discounts?.length) {
        globalDiscountStore.discounts.forEach(element => {
            let discount = element.discountType === 'PERCENTAGE' ? Math.floor(salesPrice - salesPrice * Number(element.value) / 100) : salesPrice - Number(element.value);
            
            if (element.type === 'FIXED_CATEGORY' && element.valid) {
                categoryIds.forEach(category => {
                    let findItem = element?.categories?.length && element.categories.filter(i=> i.categoryId.replaceAll("-", "") === category.id.replaceAll("-", ""));
                    if (findItem.length) {
                        discountPrice = discount;
                    }
                });
            }

            if (element.type === 'FIXED_PRODUCT' && element.valid) {
                let findItem = element?.items?.length && element.items.filter(i=> i.itemId === props.item.id && !i?.skuCode?.length);
                if (findItem.length) {
                    discountPrice = discount;
                }
            }
        });
    }

    return discountPrice;
});

const total = computed(() => {
    let discountedPrice = 0;
    let salesPrice = 0;
    if (currenciesStore?.country?.currency != "BDT" &&
        currenciesStore?.country?.rate > 0
    ) {
        if (globalDiscount.value > 0) {
            discountedPrice = (
                Number(globalDiscount.value) /
                Number(currenciesStore.country.rate)
            ).toFixed(2);
        }
        if (addToCartSection.value.configurePrice > 0) {
            salesPrice = (
                Number(addToCartSection.value.configurePrice) /
                Number(currenciesStore.country.rate)
            ).toFixed(2);
        }
    } else {
        if (globalDiscount.value > 0) {
            discountedPrice = Number(globalDiscount.value);
        }
        if (addToCartSection.value.configurePrice > 0) {
            salesPrice = Number(addToCartSection.value.configurePrice);
        }
    }

    return {
        discountedPrice: discountedPrice,
        salesPrice: salesPrice,
    };
});

const addToCart = async () => {
    if (selectSize.value?.length) {
        selectSize.value.forEach(item => {
            let submitData = {
                product: JSON.parse(JSON.stringify(item.item)),
                quantity: item.quantity,
                sku: item.sku,
            };
            if (item?.item?.id?.length) {
                cartStore.addToCart(submitData);
                toaster.value.success(`Added to Your Cart`, 1500);
            } else {
                toaster.value.error(`Please select options`, 1500);
            }
        });
    }

     /*TODO: add to cart BUNDLE*/
    // if (selectQty.value?.name > 0) {
    //     let submitData = {
    //         product: JSON.parse(JSON.stringify(props.item)),
    //         quantity: selectQty.value?.name,
    //         sku: addToCartSection.value.sku,
    //         sourceType: "bundle",
    //         salesPrice: addToCartSection.value.configurePrice,
    //     };
    //     console.log("props.item");
    //     console.log(props.item);
    //     console.log({ submitData });
    //     // if (useItemDto.value.selectedSku() != null) {
    //     if (props.item?.id?.length) {
    //         // submitData.sku = useItemDto.value.selectedSku();
    //         cartStore.addToCart(submitData);
    //         toaster.value.success(`Added to Your Cart`, 1500);
    //     } else {
    //         toaster.value.error(`Please select options`, 1500);
    //     }
    // }
};

const checkout = async () => {
    await addToCart();
    navigateTo('cart')    
};

const setFinishes = () => {
    if (props.finishes?.length) {
        selectFinish.value = finishList.value.filter(
            (i) => i.name.toLowerCase() === props.finishes
        )[0];
    }
};

const setSelectors = () => {
    if (props.section) {
        image.value = props.section.image;
        title.value = props.section.title;
        configurePrice.value = props.section.configurePrice;
        firstPera.value = props.section.firstPera;
        secondPera.value = props.section.secondPera;
        deliveryInfo.value = props.section.deliveryInfo;
        returnPolicy.value = props.section.returnPolicy;
        returnPolicyText.value = props.section.returnPolicyText;
        model.value = props.section.model;
    }
};

const buyingChoices = computed(() => {
    let inputArray = [];
    let itemArray = [];
    if (props?.item?.items?.length) {
        let items = props?.item?.items;
        let skus = props?.item?.skuDetails;
        
        if (skus?.length) {
            skus.forEach(sku => {
                let index = items.findIndex(i => i.id == sku.itemId);
                if (index > -1) {
                    
                    inputArray.push({
                        itemTitle: items[index].title,
                        itemCode: items[index].code,
                        itemModel: items[index].model,
                        ...sku
                    })
                    let item = items[index];
                    delete item.images;
                    item.images = [];
                    item.skus = [sku]
                    let images = [];
                    if (props.attachments?.length) {
                        let index = props.attachments.findIndex(i => i.itemId == item.id);
                        if (index > -1) {
                            item.images = props.attachments[index].images;
                        }
                    }

                    itemArray.push({
                        ...item
                    })
                    // items[index].skus.push(sku);
                }
            });
        }
    }
    // if (props.attachments?.length && itemArray.length) {
    //     itemArray.forEach(element => {
            
    //     });
    // }
    console.log("itemArray");
    console.log(itemArray);
    return itemArray?.length ? itemArray : [];
});

function findMatchingObject(skus, size) {
  return skus.find((sku) => {
    if (
      size.every((sizeOption) =>
        sku.optionValues.some(
          (skuOption) =>
            skuOption.optionId === sizeOption.optionId &&
            skuOption.id === sizeOption.id
        )
      )
    ) {
      return true;
    }
    return false;
  });
}

// watch(selectSize,
//     (newVal) => {
//         if (newVal.length == buyingChoices.value.length && itemRef.value?.skus?.length) {
//             // let hasSku = props.item.skus.filter( i => {
//             //     // return i.optionValues.some( s => s)
//             // })
//             let skusArr = itemRef.value?.skus;
//             if (skusArr.length) {
//                 console.log(skusArr);
//                 let matchingSku = findMatchingObject(skusArr, newVal);
    
//                 if (matchingSku) {
//                     addToCartSection.value.configurePrice = matchingSku?.salesPrice ? matchingSku.salesPrice : 0;
//                     addToCartSection.value.sku = matchingSku;
//                 } else {
//                     console.log('No matching SKU found');
//                 }
//             }

//         }
//     },
//     { immediate: true, deep: true }
// );

watch(()=> props.item,
    (newVal) => {
        if (newVal?.title?.length) {
            let skus = props.item?.skus?.length ? props.item.skus : [];
            let images = props.item?.images?.length ? props.item.images : [];
            let totalPrice = props.item?.skuDetails?.length ? props.item?.skuDetails.reduce((sum, sku) => sum + sku.salesPrice, 0) : 0;
            addToCartSection.value.image = images?.length ? images[0]?.url : 0;
            addToCartSection.value.title = props.item.title;
            addToCartSection.value.configurePrice = totalPrice;
            // addToCartSection.value.model = props.item.model;
        }
    },
    { immediate: true, deep: true }
);

watchEffect(() => {
    setSelectors();
    setFinishes();
});
</script>

<style lang="scss">
.details-bg-color {
    background-color: #f9f7f3;
}
</style>
